import { render, staticRenderFns } from "./audit-debts.vue?vue&type=template&id=0db89461"
import script from "./audit-debts.vue?vue&type=script&lang=js"
export * from "./audit-debts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports